import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from '@angular/common';

@Pipe({name: 'replaceString'})
export class ReplaceStringPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) {
    }

    transform(value: string, args?: any): string {
        if (!value) return '';
        const currentYear = new Date().getFullYear();
        value = value.replace(/{{year}}/g, currentYear.toString());
        // For each argument
        for (const key of Object.keys(args)) {
            if (args.hasOwnProperty(key) && value) {
                switch (key) {
                    /* Currency Format variables goes here: convert number into currency */
                    case 'minimumOpeningDeposit':
                    case 'maxDepositAmount':
                        if (Number(args[key]) || args[key] === "0") {
                            args[key] = this.currencyPipe.transform(args[key], 'USD', 'symbol', '1.0-0');
                        }
                        break;
                }
                value = value ? value.replace('{{' + key + '}}', args[key]) : '';
            }
        }

        return value;
    }
}
